<template>
  <Tables
    ref="tableGrid"
    :columns="['Nome', 'Tipo de Pessoa', 'Idade', 'Email', 'Última Interação']"
    :showTipFooter="false"
    @Load="onLoadBirthdays"
  >
    <tr v-for="obj in this.objList" v-bind:key="obj.id">
      <TableColumn :IsText="true" :status="1" :value="obj.nome ? obj.nome : ''"
                   @Edit="openAssociatePage(obj.idAssociado)"/>
      <TableColumn :IsText="true" :status="1" :value="obj.tipoPessoa ? obj.tipoPessoa : ''"
                   @Edit="openAssociatePage(obj.idAssociado)"/>
      <TableColumn :IsText="true" :status="1" :value="obj.dataNascimento ? moment().diff(moment.tz(obj.dataNascimento, 'America/Sao_Paulo'), 'years').toString() : ''"
                   @Edit="openAssociatePage(obj.idAssociado)"/>
      <TableColumn :IsText="true" :status="1" :value="obj.email ? obj.email : ''"
                   @Edit="openAssociatePage(obj.idAssociado)"/>
      <TableColumn :IsDatetime="true" :status="1" :value="obj.ultimaInteracao ? obj.ultimaInteracao : ''"
                   @Edit="openAssociatePage(obj.idAssociado)"/>
    </tr>
  </Tables>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'

export default {
  name: 'BirthdayTable',
  mixins: [ActionsForm],
  methods: {
    async onLoad () {
      await this.onLoadBirthdays()
    },
    async onLoadBirthdays () {
      const response = await PersonRepository.GetAniversariantesPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
      this.onResultGrid(response)
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'AssociatePage',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      // window.open(routeData.href)
      // this.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/StartPage/BirthdayTable.vue